import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * @description
 * Safely prettify a JSON object into HTML while preserving spaces
 * Uses DomSanitizer to protect against XSS attacks
 */
@Pipe({
  name: 'jsonPrettify',
  standalone: false
})
export class JsonPrettifyPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(json: object): SafeHtml {
    if (!json) {
      return '';
    }

    const escaped = this.escape(JSON.stringify(json, null, 4));

    return this.sanitizer.sanitize(SecurityContext.HTML, escaped);
  }

  private escape(unsafe: string): string {
    return unsafe
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')
      .replace(/ /g, '&nbsp;')
      .replace(/\n/g, '<br/>');
  }
}
